import { styled } from '@mui/material';

export const Wrapper = styled('div')`
  background-color: rgba(19, 19, 19, 0.5);
  border: 1px solid #262626;
  border-radius: 11px;
  background-image: linear-gradient(135deg, rgba(68,68,68,0.05) 0%,rgba(68,68,68,0) 50%,rgba(68,68,68,0.05) 100%);
`;